<template>
  <div class='news-send'>
    <div class="YTitle">消息发送列表</div>

    <div class="from">
      <el-form :inline="true" class="demo-form-inline">
        <el-form-item class="YButtonRight">
          <el-button type="success" @click="send" round>发送消息</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="table YTable">
      <el-table
        :data="TableData"
        v-loading="loading"
        border
        height='100%'
        style="width: 100%">
        <el-table-column
          v-for="(item, index) in TableHead"
          :key="index"
          :prop="item.prop"
          :label="item.label"
          show-overflow-tooltip
          align='center'>
        </el-table-column>
        <el-table-column
          align='center'
          label="操作">
          <template slot-scope="scope">
            <el-button @click="details(scope.row)" type="text" size="small">详情</el-button>
            <el-button @click="cancel(scope.row)" type="text" size="small"><span style="color: #f56c6c">删除</span></el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <YPagination
      :pageNum='pageNum'
      :pageSize='pageSize'
      :Total='Total'
      @SizeChange='SizeChange'
      @CurrentChange='CurrentChange'>
    </YPagination>

    <Send v-if="SendShow" @close='close'></Send>

    <Details v-if="DetailsShow" :DetailsData='DetailsData' @close='close'></Details>
  </div>
</template>

<script>
import Send from './components/send'
import api from '@/shared/api/apps/news'
import Details from './components/details'
export default {
  name: 'newsSend',

  components: { Send, Details },

  data () {
    return {
      pageNum: 1,
      pageSize: 10,
      Total: 0,
      loading: false,
      SendShow: false,
      DetailsShow: false,
      DetailsData: {},
      TableHead: [
        {
          prop: 'id',
          label: 'ID'
        },
        {
          prop: 'notifyTitle',
          label: '消息标题'
        },
        {
          prop: 'createUserRealName',
          label: '发送人'
        },
        {
          prop: 'createTime',
          label: '发送时间'
        }
      ],
      TableData: []
    }
  },

  mounted () {
    this.init()
  },

  methods: {
    init () {
      this.getData()
    },

    getData () {
      const params = {
        method: api.sendList,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        searchType: 1
      }

      this.axios.post(params).then(res => {
        if (res.data.backend_odc_notify_instantiation_page_list_response.code !== '10000') return
        this.TableData = res.data.backend_odc_notify_instantiation_page_list_response.result.records
        this.Total = parseInt(res.data.backend_odc_notify_instantiation_page_list_response.result.total)
      })
    },

    send () {
      this.SendShow = true
    },

    details (val) {
      this.DetailsData = val
      this.DetailsShow = true
    },

    SizeChange (val) {
      this.pageSize = val
      this.pageNum = 1
      this.getData()
    },

    CurrentChange (val) {
      this.pageNum = val
      this.getData()
    },

    close (val) {
      this.SendShow = false
      this.DetailsShow = false
      if (val !== 1) return
      this.getData()
    },

    cancel (val) {
      this.$confirm('是否删除该消息发送记录?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const params = {
          method: api.templateDelete,
          id: val.id
        }

        this.axios.post(params).then(res => {
          if (res.data.backend_odc_notify_instantiation_delete_response.code !== '10000') return
          this.$message({
            message: '消息发送记录删除成功',
            type: 'success'
          })
          this.getData()
        })
      }).catch(e => {})
    }
  }
}
</script>

<style lang='stylus' scoped>
  .news-send
    position relative
    width 100%
    height 100%
    display flex
    flex-direction column
    .table
      flex auto
      overflow auto
      margin-bottom 20px
</style>
